/* 🤖 this file was generated by svg-to-ts */
export const iconFdusd: {
  name: 'fdusd';
  data: string;
} = {
  name: 'fdusd',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32"><g clip-path="url(#firstdigitalusd__clip0_294_284)"><path fill="#0B0E11" d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16"/><path fill="#fff" d="M23.37 11.51h-5.45v2.35h5.45v3.84h-9.29V7.66h9.29z"/><path fill="#00E98D" d="M17.92 20.06v4.28H8.63v-4.28z"/></g><defs><clipPath id="firstdigitalusd__clip0_294_284"><path fill="#fff" d="M0 0h32v32H0z"/></clipPath></defs></svg>`,
};
